(() => {
  'use strict';
  if (window.SSPTruemedDisplay) return;
  let config;
  try { config = JSON.parse(document.getElementById('ssp-truemed-config').textContent); } catch (_) { return; }
  const theme = window.Shopify && window.Shopify.theme;
  const preview = config.preview === true && theme && String(theme.id) === config.previewThemeId && theme.role === 'unpublished';
  const active = config.enabled === true;
  const allowed = active || preview;
  const states = new Map();
  function qualify(rows, id, sku) {
    const row = rows[String(id)];
    return !!row && row.eligible === true && typeof sku === 'string' && sku.length > 0 && row.sku === sku;
  }
  function initProduct(note) {
    if (states.has(note)) { states.get(note).resolve(); return; }
    let rows;
    try { rows = JSON.parse(note.querySelector('[data-ssp-truemed-variants]').textContent); } catch (_) { return; }
    const scope = note.closest('.main-product') || note.closest('.shopify-section');
    if (!scope) return;
    let unsubscribe = null;
    let readinessTimer = null;
    let readinessAttempts = 0;
    function show(variant) {
      note.hidden = !allowed || !variant || !qualify(rows, variant.id, variant.sku);
      note.dataset.selectedVariant = variant ? String(variant.id) : '';
    }
    function resolve() {
      const picker = scope.querySelector('variant-picker');
      if (picker) {
        if (picker.matches(':defined') && Object.prototype.hasOwnProperty.call(picker, 'currentVariant')) { show(picker.currentVariant); return; }
        note.hidden = true;
        if (!readinessTimer && readinessAttempts < 40 && note.isConnected) {
          readinessAttempts += 1;
          readinessTimer = setTimeout(() => { readinessTimer = null; resolve(); }, 500);
        }
        return;
      }
      const field = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      const id = field ? field.value : note.dataset.selectedId;
      show(rows[id] ? {id, sku: rows[id].sku} : null);
    }
    function change(event) {
      if (event.target.closest('variant-picker') || event.target.matches('[name="id"], select[name^="options"], input[name^="options"]')) {
        note.hidden = true;
        requestAnimationFrame(resolve);
      }
    }
    scope.addEventListener('change', change, true);
    const events = window.MinimogEvents;
    if (events && typeof events.subscribe === 'function') {
      unsubscribe = events.subscribe(`${note.dataset.productId}__VARIANT_CHANGE`, (variant, picker) => {
        if (picker && !scope.contains(picker)) return;
        show(variant || null);
      });
    }
    states.set(note, {resolve, cleanup: () => { clearTimeout(readinessTimer); scope.removeEventListener('change', change, true); if (unsubscribe) unsubscribe(); }});
    resolve();
    if (window.customElements) customElements.whenDefined('variant-picker').then(() => { if (note.isConnected) resolve(); });
  }
  function init() {
    document.querySelectorAll('[data-ssp-truemed-preview]').forEach(el => { el.hidden = !preview || active; });
    document.querySelectorAll('[data-ssp-truemed-surface]').forEach(el => { el.hidden = !allowed; });
    document.querySelectorAll('[data-ssp-truemed-inactive]').forEach(el => { el.hidden = !!allowed; });
    document.querySelectorAll('[data-ssp-truemed-product]').forEach(initProduct);
    document.querySelectorAll('[data-ssp-truemed-option-select]').forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const card = select.closest('[data-ssp-truemed-option]');
        const url = select.value;
        if (!url.startsWith('/products/') || !url.includes('?variant=')) return;
        card.querySelectorAll('[data-ssp-truemed-option-link]').forEach(link => { link.href = url; });
      });
    });
    states.forEach((state, node) => { if (!node.isConnected) { state.cleanup(); states.delete(node); } });
  }
  window.SSPTruemedDisplay = {active, preview: !!preview, qualify};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
  window.addEventListener('pageshow', init);
  window.addEventListener('popstate', () => requestAnimationFrame(() => {
    states.forEach((state, node) => { state.cleanup(); states.delete(node); }); init();
  }));
})();
